<div class="cardapio-dashboard">

  <!-- Estado: sem projeto -->
  <div *ngIf="status === 'sem_projeto'" class="cd-estado">
    <i class="fas fa-chart-line cd-estado-icone"></i>
    <h3>Analytics não configurado</h3>
    <p>O projeto de analytics ainda não foi configurado para esta loja. Entre em contato com o suporte para ativar.</p>
  </div>

  <!-- Estado: erro -->
  <div *ngIf="status === 'erro'" class="cd-estado">
    <i class="fas fa-exclamation-triangle cd-estado-icone cd-estado-icone-erro"></i>
    <h3>Erro ao carregar analytics</h3>
    <p>{{ erroMensagem || 'Não foi possível acessar os dados de analytics.' }}</p>
    <button class="btn btn-outline-primary mt-2" (click)="carregueDashboard()">Tentar novamente</button>
  </div>

  <!-- Estado: carregando inicial -->
  <div *ngIf="status === 'carregando'" class="cd-estado">
    <div class="cd-spinner"></div>
    <p>Carregando...</p>
  </div>

  <!-- Dashboard principal -->
  <ng-container *ngIf="status === 'pronto'">

    <!-- HEADER -->
    <div class="cd-header">
      <div class="cd-header-left">
        <h2 class="cd-titulo">Análise do Cardápio</h2>
        <p class="cd-subtitulo">Funil de conversão do cardápio digital</p>
        <p class="cd-meta">
          Comparando com o período anterior &middot; Fuso: {{ obtenhaFusoHorario() }}
        </p>
      </div>
      <div class="cd-header-right">
        <app-periodo-segmentado
          [periodos]="periodos"
          [selecionado]="quickDateFilter"
          [disabled]="carregando"
          (periodoSelecionado)="selecionePreset($event)">
        </app-periodo-segmentado>
      </div>
    </div>

    <!-- SKELETON LOADING -->
    <ng-container *ngIf="carregando">
      <section class="cd-secao">
        <div class="cd-skeleton-label"></div>
        <div class="cd-funil-cards">
          <div class="cd-funil-card" *ngFor="let s of [1,2,3,4,5]">
            <div class="cd-skeleton cd-skeleton-text" style="width:60%"></div>
            <div class="cd-skeleton cd-skeleton-number"></div>
            <div class="cd-skeleton cd-skeleton-text" style="width:40%;margin-top:6px"></div>
            <div class="cd-skeleton cd-skeleton-bar"></div>
          </div>
        </div>
      </section>
      <section class="cd-secao">
        <div class="cd-skeleton-label"></div>
        <div class="cd-skeleton cd-skeleton-bar-full" style="height: 120px;"></div>
      </section>
      <section class="cd-secao cd-secao-dupla">
        <div class="cd-bloco-duplo">
          <div class="cd-bloco">
            <div class="cd-skeleton cd-skeleton-text" style="width:50%"></div>
            <div class="cd-skeleton cd-skeleton-chart"></div>
          </div>
          <div class="cd-bloco">
            <div class="cd-skeleton cd-skeleton-text" style="width:50%"></div>
            <div class="cd-skeleton cd-skeleton-bar-full" *ngFor="let s of [1,2,3,4]"></div>
          </div>
        </div>
      </section>
    </ng-container>

    <!-- ERRO -->
    <div class="alert alert-danger cd-alerta" *ngIf="erroMensagem && !carregando">
      {{ erroMensagem }}
      <button class="btn btn-sm btn-outline-danger ml-2" (click)="carregueDashboard()">Tentar novamente</button>
    </div>

    <!-- ALERTAS DO BACKEND -->
    <div *ngFor="let alerta of alertas" class="cd-alerta-backend"
         [class.cd-alerta-warning]="alerta.severidade === 'warning'"
         [class.cd-alerta-danger]="alerta.severidade === 'danger'"
         [class.cd-alerta-info]="alerta.severidade === 'info'">
      <i class="fas" [ngClass]="{
        'fa-exclamation-triangle': alerta.severidade === 'warning' || alerta.severidade === 'danger',
        'fa-info-circle': alerta.severidade === 'info'
      }"></i>
      <div>
        <strong>{{ alerta.titulo }}</strong>
        <span>{{ alerta.descricao }}</span>
      </div>
    </div>

    <!-- BANNER EXECUTIVO -->
    <div class="cd-banner" *ngIf="bannerResumo && !carregando">
      <i class="fas fa-lightbulb cd-banner-icone"></i>
      <span>{{ bannerResumo }}</span>
    </div>

    <!-- METRICAS GERAIS -->
    <section class="cd-secao">
      <h3 class="cd-secao-titulo">MÉTRICAS DE ANALYTICS</h3>
      <div class="cd-analytics-cards" *ngIf="obtenhaCardsAnalytics().length">
        <div class="cd-analytics-card" *ngFor="let card of obtenhaCardsAnalytics()">
          <span class="cd-analytics-card-label">{{ card.label }}</span>
          <span class="cd-analytics-card-valor">{{ card.valor | number }}</span>
          <span class="cd-analytics-card-desc">{{ card.descricao }}</span>
          <span class="cd-analytics-card-variacao" *ngIf="card.variacao">
            {{ card.variacao }}
          </span>
        </div>
      </div>
    </section>

    <!-- VISAO GERAL DO FUNIL -->
    <section class="cd-secao">
      <h3 class="cd-secao-titulo">VISÃO GERAL DO FUNIL</h3>
      <div class="cd-funil-cards cd-funil-cards-resumo" *ngIf="steps.length">
        <div class="cd-funil-card cd-funil-card-resumo" *ngFor="let step of steps; let i = index"
             style="background: #fff">
          <div class="cd-funil-resumo-topo">
            <span class="cd-funil-card-label">{{ step.label }}</span>
            <span class="cd-funil-card-valor">{{ step.count | number }}</span>
            <span class="cd-funil-resumo-descricao">{{ obtenhaDescricaoStep(step.key) }}</span>
            <span class="cd-funil-resumo-variacao"
                  [class.positiva]="obtenhaClasseVariacaoStep(step) === 'positiva'"
                  [class.negativa]="obtenhaClasseVariacaoStep(step) === 'negativa'"
                  [class.neutra]="obtenhaClasseVariacaoStep(step) === 'neutra'"
                  *ngIf="obtenhaTextoVariacaoStep(step)">
              <i class="fas" [ngClass]="obtenhaIconeVariacaoStep(step)"></i>
              {{ obtenhaTextoVariacaoStep(step) }}
            </span>
          </div>
          <div class="cd-funil-resumo-meter">
            <svg class="cd-funil-resumo-wave" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
              <defs>
                <linearGradient [attr.id]="'cd-funil-grad-' + i" x1="0%" y1="0%" x2="0%" y2="100%">
                  <stop offset="0%" [attr.stop-color]="obtenhaCorStep(step.key)"></stop>
                  <stop offset="100%" [attr.stop-color]="obtenhaCorStepFinal(step.key)"></stop>
                </linearGradient>
              </defs>
              <path [attr.d]="obtenhaWavePath(i)"
                    [attr.fill]="'url(#cd-funil-grad-' + i + ')'"></path>
            </svg>
            <span class="cd-funil-resumo-percent"
                  [style.top]="obtenhaOffsetPercentualResumo(i)"
                  [class.cd-funil-resumo-percent-claro]="obtenhaClassePercentualResumo(i) === 'claro'"
                  [class.cd-funil-resumo-percent-escuro]="obtenhaClassePercentualResumo(i) === 'escuro'">
              {{ obtenhaPercentualResumo(i) }}
            </span>
          </div>
        </div>
      </div>
      <div class="cd-sem-dados" *ngIf="!steps.length && !carregando">
        <i class="fas fa-chart-bar"></i>
        <span>Ainda não há dados de funil para o período selecionado</span>
      </div>
    </section>

    <!-- CONVERSAO DIARIA + GARGALOS -->
    <section class="cd-secao cd-secao-dupla">
      <div class="cd-bloco-duplo">
        <div class="cd-bloco">
          <h3 class="cd-secao-titulo">Conversão Diária</h3>
          <p class="cd-secao-subtitulo">Taxa visita &rarr; pedido concluído</p>
          <div class="cd-chart-wrapper" *ngIf="temDadosSerieConversao()">
            <kendo-chart [transitions]="false">
              <kendo-chart-category-axis>
                <kendo-chart-category-axis-item [categories]="categoriesConversao"
                  [majorTicks]="{ visible: false }"
                  [majorGridLines]="{ visible: false }"
                  [labels]="rotulosConversao">
                </kendo-chart-category-axis-item>
              </kendo-chart-category-axis>
              <kendo-chart-value-axis>
                <kendo-chart-value-axis-item
                  [min]="0"
                  [max]="obtenhaMaximoConversaoGrafico()"
                  [majorUnit]="obtenhaMajorUnitConversaoGrafico()"
                  [line]="{ visible: false }"
                  [labels]="{ format: '{0}%', font: '11px sans-serif', color: '#94a3b8' }">
                </kendo-chart-value-axis-item>
              </kendo-chart-value-axis>
              <kendo-chart-series>
                <kendo-chart-series-item type="area" [data]="seriesConversaoPlot"
                  color="rgba(37, 99, 235, 0.14)"
                  [line]="{ color: 'transparent' }"
                  [opacity]="1"
                  [markers]="{ visible: false }">
                </kendo-chart-series-item>
                <kendo-chart-series-item type="line" [data]="seriesConversaoPlot"
                  style="smooth"
                  color="#2563EB" [width]="2.5"
                  [markers]="{ visible: true, size: 6, background: '#ffffff', border: { width: 2, color: '#2563EB' } }">
                </kendo-chart-series-item>
              </kendo-chart-series>
              <kendo-chart-tooltip [visible]="true">
                <ng-template kendoChartSeriesTooltipTemplate let-category="category">
                  <div class="cd-chart-tooltip" *ngIf="obtenhaTooltipConversao(category) as tooltip">
                    <div class="cd-chart-tooltip-data">{{ tooltip.data }}</div>
                    <div class="cd-chart-tooltip-item">
                      <strong>{{ tooltip.pedidos }}</strong>
                      <span class="cd-chart-tooltip-label">pedidos</span>
                    </div>
                    <div class="cd-chart-tooltip-item">
                      <strong>{{ tooltip.conversion }}</strong>
                      <span class="cd-chart-tooltip-label">de conversão</span>
                    </div>
                  </div>
                </ng-template>
              </kendo-chart-tooltip>
            </kendo-chart>
          </div>
          <p class="cd-vazio" *ngIf="!temDadosSerieConversao()">Dados insuficientes para o gráfico.</p>
        </div>

        <div class="cd-bloco">
          <h3 class="cd-secao-titulo">Passagem entre Etapas</h3>
          <p class="cd-secao-subtitulo">Taxa de continuidade entre etapas consecutivas</p>
          <div class="cd-gargalos" *ngIf="gargalos?.length">
            <div class="cd-gargalo" *ngFor="let g of gargalos">
              <span class="cd-gargalo-label">{{ g.de }} &rarr; {{ g.para }}</span>
              <div class="cd-gargalo-barra-wrapper">
                <div class="cd-gargalo-barra"
                     [style.width.%]="obtenhaBarWidth(g.transitionPercent)"
                     [style.background-color]="obtenhaBarColor(g.transitionPercent)">
                </div>
                <span class="cd-gargalo-valor">{{ g.transitionPercent.toFixed(1) }}%</span>
              </div>
            </div>
          </div>
          <p class="cd-vazio" *ngIf="!gargalos?.length">Ainda não há dados de passagem entre etapas.</p>
        </div>
      </div>
    </section>

    <!-- DESEMPENHO POR PRODUTO -->
    <section class="cd-secao">
      <h3 class="cd-secao-titulo">Desempenho por Produto</h3>
      <p class="cd-secao-subtitulo">Total de eventos vs. sessões únicas &middot; Taxas calculadas sobre sessões</p>
      <div class="cd-tabela-wrapper" *ngIf="produtos.length">
        <table class="cd-tabela">
          <thead>
            <tr>
              <th class="cd-tabela-th-rank">#</th>
              <th class="cd-tabela-th-produto">PRODUTO</th>
              <th>VIEWS</th>
              <th>VIEWS (SESSOES)</th>
              <th>SACOLA</th>
              <th>PEDIDOS</th>
              <th>TAXA ADD</th>
              <th>CONV. PEDIDO</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let p of produtos; let i = index">
              <td class="cd-tabela-rank">{{ i + 1 }}</td>
              <td class="cd-tabela-produto">{{ p.title }}</td>
              <td>{{ p.views | number }}</td>
              <td>{{ p.uniqueViews | number }}</td>
              <td>{{ p.addToCart | number }}</td>
              <td>{{ p.pedidos | number }}</td>
              <td>{{ p.addToCartRate }}%</td>
              <td>{{ p.purchaseRate }}%</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="cd-sem-dados" *ngIf="!produtos.length && !carregando">
        <i class="fas fa-box-open"></i>
        <span>Ainda não há dados de produtos para o período selecionado</span>
      </div>
    </section>

    <!-- TOP RANKINGS -->
    <section class="cd-secao">
      <h3 class="cd-secao-titulo">TOP RANKINGS</h3>
      <div class="cd-top-rankings" *ngIf="produtos.length">
        <div class="cd-top-ranking">
          <h4 class="cd-top-titulo">Top Visualizações</h4>
          <div class="cd-top-item" *ngFor="let p of topVisualizacoes; let i = index">
            <span class="cd-top-pos" [class.cd-top-pos-1]="i === 0">{{ i + 1 }}</span>
            <span class="cd-top-nome">{{ p.title }}</span>
            <span class="cd-top-valor">{{ p.views | number }}</span>
          </div>
        </div>
        <div class="cd-top-ranking">
          <h4 class="cd-top-titulo">Top Sacola</h4>
          <div class="cd-top-item" *ngFor="let p of topSacola; let i = index">
            <span class="cd-top-pos" [class.cd-top-pos-1]="i === 0">{{ i + 1 }}</span>
            <span class="cd-top-nome">{{ p.title }}</span>
            <span class="cd-top-valor">{{ p.addToCart | number }}</span>
          </div>
        </div>
        <div class="cd-top-ranking">
          <h4 class="cd-top-titulo">Top Pedidos</h4>
          <div class="cd-top-item" *ngFor="let p of topPedidos; let i = index">
            <span class="cd-top-pos" [class.cd-top-pos-1]="i === 0">{{ i + 1 }}</span>
            <span class="cd-top-nome">{{ p.title }}</span>
            <span class="cd-top-valor">{{ p.pedidos | number }}</span>
          </div>
        </div>
      </div>
      <div class="cd-sem-dados" *ngIf="!produtos.length && !carregando">
        <i class="fas fa-trophy"></i>
        <span>Ainda não há dados de ranking para o período</span>
      </div>
    </section>

    <!-- FONTES DE TRÁFEGO -->
    <section class="cd-secao">
      <div class="cd-secao-dupla-bottom" *ngIf="campanhas?.source?.length || campanhas?.referrer?.length">
        <div class="cd-bloco">
          <h3 class="cd-secao-titulo">Fontes de Tráfego</h3>
          <p class="cd-secao-subtitulo">Source / UTM / Referrer por sessão</p>
          <table class="cd-tabela cd-tabela-sm">
            <thead>
              <tr>
                <th>FONTE / CAMPANHA</th>
                <th>SESSOES</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let s of (campanhas?.source?.length ? campanhas.source : campanhas.referrer)?.slice(0, 8)">
                <td>{{ s.name || s.key || s.value || '-' }}</td>
                <td>{{ s.count || s.sessions || 0 | number }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="cd-bloco">
          <h3 class="cd-secao-titulo">Novos vs. Recorrentes</h3>
          <p class="cd-secao-subtitulo">Comportamento por tipo de visitante</p>
          <div class="cd-novos-recorrentes">
            <p class="cd-vazio">Dados de novos vs. recorrentes serão disponibilizados em breve.</p>
          </div>
        </div>
      </div>
      <div class="cd-sem-dados" *ngIf="!(campanhas?.source?.length || campanhas?.referrer?.length) && !carregando">
        <i class="fas fa-globe"></i>
        <span>Ainda não há dados de fontes de tráfego para o período</span>
      </div>
    </section>

    <section class="cd-secao" *ngIf="temIframesOpenpanel()">
      <h3 class="cd-secao-titulo">OPENPANEL (IFRAME)</h3>
      <p class="cd-secao-subtitulo">Dashboard compartilhado e widget de tempo real</p>
      <div class="cd-openpanel-grid">
        <div class="cd-openpanel-card" *ngIf="openpanelRealtimeIframe">
          <div class="cd-openpanel-header">
            <span>Tempo real</span>
            <a [href]="openpanelRealtimeUrl" target="_blank" rel="noopener noreferrer">Abrir</a>
          </div>
          <iframe
            class="cd-openpanel-iframe cd-openpanel-iframe-realtime"
            [src]="openpanelRealtimeIframe"
            title="OpenPanel Realtime"
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade">
          </iframe>
        </div>
        <div class="cd-openpanel-card" *ngIf="openpanelDashboardIframe">
          <div class="cd-openpanel-header">
            <span>Dashboard OpenPanel</span>
            <a [href]="openpanelDashboardUrl" target="_blank" rel="noopener noreferrer">Abrir</a>
          </div>
          <iframe
            class="cd-openpanel-iframe"
            [src]="openpanelDashboardIframe"
            title="OpenPanel Dashboard"
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade">
          </iframe>
        </div>
      </div>
    </section>

  </ng-container>
</div>
